import Exercise from './Exercise';

export default Exercise;
